export const depositModal = {
  invoke: [
    {
      src: 'watchDepositModalCloseAction',
      cond: 'isHeaderInVisibleMode',
    },
    {
      src: 'watchDepositModalOpenAction',
      cond: 'isHeaderInVisibleMode',
    },
  ],
};
